import React from 'react';
import Style from './style.sass';
const Button = ({text, onClick}) => {
  return (
    <div className={Style.Button} onClick={onClick}>
      <p>{text}</p>
    </div>
  )
};

export default Button;